import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CopyEmailComponent } from '../../../../shared/components/copy-email/copy-email.component';
import { CONTACT } from '../../../../core/contact.config';
import { ConsentService } from '../../../../core/services/consent.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, CopyEmailComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  private readonly consent = inject(ConsentService);
  currentYear = new Date().getFullYear();

  contactEmail = CONTACT.email;

  navLinks = [
    { label: 'About us',       path: '/about'          },
    { label: 'Services',       path: '/services'       },
    { label: 'Destinations',    path: '/destinations'   },
    { label: 'Partners',        path: '/partners'       },
    { label: 'Blog',           path: '/blog'           },
    { label: 'Contact',        path: '/contact'        }, // public since MV-378 (PRD §3.6)
  ];

  legalLinks = [
    { label: 'Terms & Conditions',      path: '/terms-and-conditions'     },
    { label: 'Privacy Policy',          path: '/privacy-policy'           },
    { label: 'Accessibility Statement', path: '/accessibility-statement'  },
    { label: 'Refund Policy',           path: '/refund-policy'            },
  ];

  openCookieSettings(event: Event): void {
    event.preventDefault();
    this.consent.openManagePanel();
  }
}
